import List from './List.vue';
import Edit from './Edit.vue';

// OrderViewRoutes
export default [{
  path: '/manage_rules',
  name: 'manage rules',
  props: true,
  component: () => import(/* webpackChunkName: "page-manage-rules" */ './Rules.vue'),
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: 'list',
      component: List,
    },
    {
      path: 'new',
      name: 'New Rule',
      component: Edit,
      props: { new: true },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: 'edit/:id',
      name: 'Edit Rule',
      component: Edit,
      props: true,
      meta: {
        requiresAuth: true,
      },
    }
  ],
}];
